package com.partejar.app.core.ui.theme

import androidx.lifecycle.ViewModel
import com.partejar.app.core.preferences.ThemePreferenceRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class AppThemeViewModel(
    private val repository: ThemePreferenceRepository
) : ViewModel() {

    private val _themeMode = MutableStateFlow(repository.getThemeMode())
    val themeMode: StateFlow<ThemeMode> = _themeMode.asStateFlow()

    fun setThemeMode(themeMode: ThemeMode) {
        repository.setThemeMode(themeMode)
        _themeMode.value = themeMode
    }

    fun toggleManualTheme(isDarkTheme: Boolean) {
        val newMode = if (isDarkTheme) ThemeMode.LIGHT else ThemeMode.DARK
        setThemeMode(newMode)
    }
}
